import { render } from "./StaticPlayer.vue?vue&type=template&id=40a595c4&scoped=true"
import script from "./StaticPlayer.vue?vue&type=script&lang=js"
export * from "./StaticPlayer.vue?vue&type=script&lang=js"

import "./StaticPlayer.vue?vue&type=style&index=0&id=40a595c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40a595c4"

export default script